var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import MidmarkTextField from '../TextField/MidmarkTextField';
export default function MidmarkFormikTextField(_a) {
    var { formikProps, error, errorMessage, onChange, onBlur, name, value } = _a, others = __rest(_a, ["formikProps", "error", "errorMessage", "onChange", "onBlur", "name", "value"]);
    if (formikProps != null && name != null) {
        error =
            !formikProps.isSubmitting &&
                formikProps.touched[name] &&
                !!formikProps.errors[name];
        errorMessage = formikProps.touched[name] && formikProps.errors[name];
        value = value || formikProps.values[name];
        onChange = onChange || formikProps.handleChange;
    }
    else {
        if (value == null) {
            console.warn('No value or formikProps value specified');
        }
    }
    const modifiedOnBlur = (e) => {
        if (formikProps && name) {
            !formikProps.touched[name] &&
                !!value &&
                (Array.isArray(value) || value instanceof String) &&
                value.length > 0 &&
                formikProps.setFieldTouched(name);
        }
        if (onBlur) {
            onBlur(e);
        }
    };
    return (_jsx(MidmarkTextField, Object.assign({ name: name, error: error, errorMessage: errorMessage, value: value, onChange: onChange, onBlur: modifiedOnBlur }, others)));
}
